import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { ROUTE_IDS, StepDefinition } from '@lx/quote-tool/shared/types';
import { FlywirePaymentComponent } from './flywire-payment.component';

@Injectable({
  providedIn: 'root',
})
export class FlywirePaymentResolver {
  private stepDefinition: StepDefinition = {
    stepId: ROUTE_IDS.FLYWIRE_PAYMENT,
    displayQuote: false,
    nextStep: () => ROUTE_IDS.CONFIRMATION,
    previousStep: () => ROUTE_IDS.BOOKING_ENROLMENT_PAYMENT,
  };

  resolve(): StepDefinition {
    return this.stepDefinition;
  }
}

export const stepRoute: Route = {
  path: ROUTE_IDS.FLYWIRE_PAYMENT,
  resolve: {
    stepDefinition: FlywirePaymentResolver,
  },
  component: FlywirePaymentComponent,
};
